'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 25px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n'], ['\n  margin-top: 25px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  font-family: ', ';\n  font-size: 12px;\n  width: 33%;\n  display: flex;\n  align-items: center;\n  justify-self: flex-start;\n  flex-wrap: wrap;\n'], ['\n  font-family: ', ';\n  font-size: 12px;\n  width: 33%;\n  display: flex;\n  align-items: center;\n  justify-self: flex-start;\n  flex-wrap: wrap;\n']),
  _templateObject3 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: ', ';\n  white-space: nowrap;\n'], ['\n  color: ', ';\n  font-weight: ', ';\n  white-space: nowrap;\n']),
  _templateObject4 = _taggedTemplateLiteral(['\n  margin-left: 3px;\n\n  span {\n    white-space: nowrap;\n  }\n\n  button {\n    margin-left: 5px;\n    display: inline-flex;\n    color: ', ';\n    font-weight: 500;\n    padding-left: 0px;\n    padding-right: 0px;\n    margin-left: 3px;\n  }\n'], ['\n  margin-left: 3px;\n\n  span {\n    white-space: nowrap;\n  }\n\n  button {\n    margin-left: 5px;\n    display: inline-flex;\n    color: ', ';\n    font-weight: 500;\n    padding-left: 0px;\n    padding-right: 0px;\n    margin-left: 3px;\n  }\n']),
  _templateObject5 = _taggedTemplateLiteral(['\n  width: 33%;\n'], ['\n  width: 33%;\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _XactlyColors = require('../../themes/XactlyColors');
var _XactlyColors2 = _interopRequireDefault(_XactlyColors);
var _Button = require('../Button');
var _Paginator = require('./Paginator');
var _Paginator2 = _interopRequireDefault(_Paginator);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var FooterWrapper = _styledComponents2['default'].div.withConfig({
  displayName: 'DataTableFooter__FooterWrapper',
  componentId: 'sc-9l9q9z-0'
})(_templateObject);
var TableInfo = _styledComponents2['default'].span.withConfig({
  displayName: 'DataTableFooter__TableInfo',
  componentId: 'sc-9l9q9z-1'
})(_templateObject2, function (props) {
  return props.theme.fontFamily;
});
var TableTitle = _styledComponents2['default'].span.withConfig({
  displayName: 'DataTableFooter__TableTitle',
  componentId: 'sc-9l9q9z-2'
})(_templateObject3, function (props) {
  return props.theme.colorTextModerate;
}, function (props) {
  return props.theme.fontWeightSemiBold;
});
var FilterInfo = _styledComponents2['default'].span.withConfig({
  displayName: 'DataTableFooter__FilterInfo',
  componentId: 'sc-9l9q9z-3'
})(_templateObject4, _XactlyColors2['default'].xCore);
var InvisibleWrapper = _styledComponents2['default'].span.withConfig({
  displayName: 'DataTableFooter__InvisibleWrapper',
  componentId: 'sc-9l9q9z-4'
})(_templateObject5);
var getLabelRange = function () {
  function getLabelRange(currentPage, totalItems, itemsPerPage) {
    var lastPage = Math.ceil(totalItems / itemsPerPage);
    var startRange = (currentPage - 1) * itemsPerPage + 1;
    if (totalItems === 0) {
      return 0;
    }
    if (currentPage === 1) {
      return '1 to ' + (totalItems < itemsPerPage ? totalItems : itemsPerPage);
    } else if (currentPage === lastPage) {
      return startRange + ' to ' + totalItems;
    } else {
      return startRange + ' to ' + (startRange + itemsPerPage - 1);
    }
  }
  return getLabelRange;
}();
var renderTableTitle = function () {
  function renderTableTitle(props) {
    var currentPage = props.currentPage,
      itemsPerPage = props.itemsPerPage,
      labelDataType = props.labelDataType,
      paginator = props.paginator,
      totalItems = props.totalItems;
    if (paginator) {
      var labelRange = getLabelRange(currentPage, totalItems, itemsPerPage);
      return _react2['default'].createElement(TableTitle, {
        className: 'table-title'
      }, labelRange + ' of ' + totalItems + ' ' + labelDataType);
    }
    return null;
  }
  return renderTableTitle;
}();
var renderFilterInfo = function () {
  function renderFilterInfo(props) {
    var areFiltersApplied = props.areFiltersApplied,
      filterable = props.filterable,
      clearFiltersHandler = props.clearFiltersHandler;
    if (filterable && areFiltersApplied) {
      return _react2['default'].createElement(FilterInfo, null, _react2['default'].createElement('span', null, '(Filters Applied)'), _react2['default'].createElement(_Button.SecondaryButton, {
        text: 'Clear Filters',
        clickHandler: clearFiltersHandler
      }));
    }
    return null;
  }
  return renderFilterInfo;
}();
var renderPaginator = function () {
  function renderPaginator(props) {
    var currentPage = props.currentPage,
      itemsPerPage = props.itemsPerPage,
      paginator = props.paginator,
      onPageClick = props.onPageClick,
      totalItems = props.totalItems;
    return paginator ? _react2['default'].createElement(_Paginator2['default'], {
      onPageClick: onPageClick,
      totalItems: totalItems,
      itemsPerPage: itemsPerPage,
      currentPage: currentPage
    }) : _react2['default'].createElement(InvisibleWrapper, null);
  }
  return renderPaginator;
}();
var DataTableFooter = function () {
  function DataTableFooter(props) {
    return _react2['default'].createElement(FooterWrapper, null, _react2['default'].createElement(TableInfo, null, renderTableTitle(props), renderFilterInfo(props)), renderPaginator(props), _react2['default'].createElement(InvisibleWrapper, null));
  }
  return DataTableFooter;
}();
DataTableFooter.defaultProps = {
  clearFiltersHandler: function () {
    function clearFiltersHandler() {}
    return clearFiltersHandler;
  }(),
  onPageClick: function () {
    function onPageClick() {}
    return onPageClick;
  }()
};
DataTableFooter.propTypes = {
  /* boolean that represents if filters are currently applied */
  areFiltersApplied: _propTypes2['default'].bool.isRequired,
  /* click handler function to clear the filters */
  clearFiltersHandler: _propTypes2['default'].func.isRequired,
  /* this props is what determines which number is highlighted and what slice is shown */
  currentPage: _propTypes2['default'].number.isRequired,
  /* boolean indicating whether filtering is turned on */
  filterable: _propTypes2['default'].bool.isRequired,
  /* This prop determines how many rows of data are shown on each page */
  itemsPerPage: _propTypes2['default'].number.isRequired,
  /* A string value that determines the title for the label, displaying ___ of____ 'labelTitle' */
  labelDataType: _propTypes2['default'].string.isRequired,
  /* boolean indicating whether pagination is turned on */
  paginator: _propTypes2['default'].bool.isRequired,
  /* This is a function that is passed in.  When it is called it will be passed the new page */
  onPageClick: _propTypes2['default'].func.isRequired,
  /* This is the length of the full array of data */
  totalItems: _propTypes2['default'].number.isRequired
};
exports['default'] = DataTableFooter;